export const setStateProjectMenuToggle = (state) => {
  return {
    menu: {
      open: !state.menu.open
    }
  };
}
